<template>
  <v-sheet
    v-if="
      formOpen &&
      userData.role != undefined &&
      (formData.hasOwnProperty('id') || selectedData.new)
    "
  >
    <v-card flat>
      <v-card-text>
        <v-form ref="impactBusinessForm">
          <v-layout class="salesForm" key="form" wrap justify-center>
            <!-- Customer Details Section -->
            <v-flex class="mb-4" xs12 md6>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar color="grey darken-2" dense dark class="mb-0">
                  Customer Details
                  <v-btn
                    :loading="creatingImpactBuyer"
                    @click="createImpactBuyer()"
                    v-if="
                      userData.role.includes('Admin') &&
                      formData.impactBusiness_id == '' &&
                      false
                    "
                    class="ml-2"
                    small
                    color="#325181"
                    >Turn into Impact Buyer</v-btn
                  >
                  <v-spacer></v-spacer>
                  <span class="textLabel">Time of Enquiry:&nbsp;</span>
                  {{ formData.dateOfEnquiry | moment }}
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex
                      xs12
                      v-if="userData.role.includes('Admin')"
                      sm6
                      class="px-1 mb-1"
                    >
                      <v-autocomplete
                        label="Impact Buyer"
                        v-model="formData.impactBusiness_id"
                        :items="impactBusinesses"
                        item-text="name"
                        item-value="business_id"
                        clearable
                        hide-details
                        @change="updateCustomerInfo"
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 v-else sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Impact Buyer"
                        v-model="formData.impactBusinessName"
                        hide-details
                        readonly
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Customer Name"
                        v-model="formData.fullName"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Customer Email"
                        v-model="formData.email"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Customer Number"
                        v-model="formData.mobile"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Customer Address"
                        v-model="formData.address"
                        :readonly="!userData.role.includes('Admin')"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      v-if="userData.role.includes('Admin')"
                      sm6
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        dense
                        label="Join Email list"
                        v-model="formData.permission"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      :xs12="userData.role.includes('Admin')"
                      :xs6="!userData.role.includes('Admin')"
                      class="px-1 mb-1"
                    >
                      <v-autocomplete
                        v-model="formData.goodCause_id"
                        :items="goodCauses"
                        item-text="name"
                        item-value="id"
                        label="Area of Impact they want to Support"
                        :clearable="userData.role.includes('Admin')"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      />
                    </v-flex>
                    <v-flex
                      v-if="$route.name != 'SalesEnquiryAdminBuyerView'"
                      xs6
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="How did you hear about us?"
                        v-model="formData.reference"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      v-if="$route.name != 'SalesEnquiryAdminBuyerView'"
                      xs6
                      class="px-1 mb-1"
                    >
                      <v-autocomplete
                        label="Referred By"
                        v-model="formData.refferedBy_business_id"
                        :items="impactBusinesses"
                        item-text="name"
                        item-value="id"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Enquiry Details Section -->
            <v-flex class="mb-4" xs12 md6>
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar color="grey darken-2" dense dark class="mb-0">
                  Enquiry Details
                  <v-tooltip v-if="formData.status == 'Unopened'" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-2" color="white" dark v-on="on">
                        mdi-email
                      </v-icon>
                    </template>
                    <span>Email Unopened</span>
                  </v-tooltip>
                  <v-tooltip v-if="formData.status == 'Opened'" bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-2" color="green" dark v-on="on">
                        mdi-email
                      </v-icon>
                    </template>
                    <span>Email Opened</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <div
                    v-if="userData.role.includes('Admin')"
                    style="postition: relative; right: 0"
                  >
                    <v-checkbox
                      label="Returning Customer"
                      v-model="formData.repeatSale"
                      hide-details
                      :readonly="!userData.role.includes('Admin')"
                    ></v-checkbox>
                  </div>
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-select
                        class="mt-0 pa-2 pt-3"
                        :style="`${
                          userData.role.includes('Admin')
                            ? formData.ibStatus == ''
                              ? ''
                              : formData.ibStatus != formData.upstreamStatus
                              ? 'background-color: rgba(237,32,36,0.3)'
                              : 'background-color: rgb(210, 238, 232)'
                            : ''
                        }`"
                        label="Sale Enquiry Status"
                        v-model="formData.upstreamStatus"
                        hide-details
                        :items="upstreamStatusList"
                        :readonly="!userData.role.includes('Admin')"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex
                      v-if="
                        userData.role.includes('Admin') &&
                        formData.ibStatus != ''
                      "
                      xs6
                      class="px-1 mb-1"
                      :style="'background-color: rgb(210, 238, 232)'"
                    >
                      <v-select
                        label="IB Status"
                        v-model="formData.ibStatus"
                        hide-details
                        :items="upstreamStatusList"
                        readonly
                      >
                      </v-select>
                    </v-flex>
                    <br />
                    <v-flex
                      v-if="
                        formData.business_id != '' &&
                        (userData.role.includes('Admin') ||
                          userData.role.includes('ImpactBusiness'))
                      "
                      xs12
                      sm6
                      class="px-1 mb-1"
                    >
                      <v-autocomplete
                        v-model="formData.business_id"
                        :items="businesses"
                        item-value="id"
                        item-text="name"
                        label="Supplier who received the enquiry"
                        clearable
                        :readonly="userData.role.includes('ImpactBusiness')"
                        hide-details
                        @change="updateSupplierInfo"
                      >
                        <template slot="selection" slot-scope="data">
                          <!-- HTML that describe how select should render selected items -->
                          <span>
                            {{ data.item.name }}
                          </span>
                          &nbsp;
                          <span
                            v-if="data.item.status == 'Left & Removed'"
                            style="font-weight: bold"
                          >
                            ( Left & Removed )
                          </span>
                          <span
                            v-if="data.item.status == 'Paused / Live'"
                            style="font-weight: bold"
                          >
                            ( Paused / Live )
                          </span>
                        </template>
                        <template slot="item" slot-scope="data">
                          <!-- HTML that describe how select should render selected items -->
                          <span>
                            {{ data.item.name }}
                          </span>
                          &nbsp;
                          <span
                            v-if="data.item.status == 'Left & Removed'"
                            style="font-weight: bold"
                          >
                            ( Left & Removed )
                          </span>
                          <span
                            v-if="data.item.status == 'Paused / Live'"
                            style="font-weight: bold"
                          >
                            ( Paused / Live )
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex
                      v-else-if="userData.role.includes('Admin')"
                      xs12
                      sm8
                      class="px-1 mb-1"
                    >
                      {{ formData.importSupplier }} ( Left & Removed )
                    </v-flex>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-autocomplete
                        label="Enquiry Via"
                        v-model="formData.via"
                        :items="viaOptions"
                        item-value="title"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      >
                        <template slot="selection" slot-scope="data">
                          <!-- HTML that describe how select should render selected items -->
                          <span class="font-weight-bold">
                            {{ data.item.title }}
                          </span>
                          &nbsp;
                          {{ data.item.description }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <!-- HTML that describe how select should render items when the select is open -->
                          <span class="font-weight-bold">
                            {{ data.item.title }}
                          </span>
                          &nbsp;
                          {{ data.item.description }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex
                      v-if="$route.name == 'SalesEnquiryAdminBuyerView'"
                      xs12
                      sm6
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="Enquiry About"
                        v-model="formData.enquiryAbout"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 class="px-1 mb-1">
                      <v-textarea
                        label="Message from Customer"
                        v-model="formData.message"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-textarea>
                    </v-flex>
                    <v-flex
                      v-if="$route.name != 'SalesEnquiryAdminBuyerView'"
                      xs12
                      :sm6="userData.role.includes('Admin')"
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="Enquiry About"
                        v-model="formData.enquiryAbout"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      v-if="$route.name == 'SalesEnquiryAdminBuyerView'"
                      xs12
                      sm6
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="Revenue"
                        v-model="formData.revenue"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      v-if="$route.name == 'SalesEnquiryAdminBuyerView'"
                      xs12
                      sm6
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="Upstream Contribution"
                        v-model="formData.upstreamContribution"
                        hide-details
                        :readonly="!userData.role.includes('Admin')"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Outcome of Sale Section -->
            <v-flex
              v-if="userData.role.includes('Admin')"
              class="mb-4"
              xs12
              md6
            >
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar color="grey darken-2" dense dark class="mb-0">
                  Outcome of Sale
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4 class="px-1 mb-1">
                      <v-text-field
                        label="Invoice #"
                        v-model="formData.xeroInv"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="px-1 mb-1">
                      <v-text-field
                        label="Total Revenue of Sale (excl Gst)"
                        v-model="formData.revenue"
                        prefix="$"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 class="px-1 mb-1">
                      <v-text-field
                        label="UpstreamNZ Contribution"
                        v-model="formData.upstreamContribution"
                        prefix="$"
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <v-checkbox
                        label="Paid To GC"
                        v-model="formData.paidToGC"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs8>
                      <v-btn
                        v-if="formData.businessLeadsInformation_id == ''"
                        block
                        color="grey darken-2"
                        @click="linkToLeadDialog = true"
                        dark
                      >
                        Link to Lead
                      </v-btn>
                    </v-flex>

                    <v-flex xs4 class="px-1 mb-1">
                      <v-textarea
                        label="Admin notes"
                        v-model="formData.adminNotes"
                        hide-details
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <v-textarea
                        label="Supplier Notes"
                        v-model="formData.supplierNotes"
                        hide-details
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs4 class="px-1 mb-1">
                      <v-textarea
                        label="IB Notes"
                        v-model="formData.ibNotes"
                        hide-details
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <!-- Other Data -->
            <v-flex
              v-if="userData.role.includes('Admin')"
              class="mb-4"
              xs12
              md6
            >
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar color="grey darken-2" dense dark class="mb-0">
                  Other Data
                  <v-spacer></v-spacer>

                  <span class="textLabel">Type of Sale:&nbsp;</span>
                  {{ formData.impactBusiness_id ? "Impact Buyer" : "Consumer" }}
                </v-toolbar>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Category of Supplier"
                        v-model="formData.businessCategories"
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 class="px-1 mb-1">
                      <v-text-field
                        label="Sub-Category of Supplier"
                        v-model="formData.businessSubCategories"
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 class="px-1 mb-1">
                      <v-slider
                        v-model="formData.chance"
                        always-dirty
                        persistent-hint
                        thumb-label="always"
                        :thumb-size="30"
                        step="10"
                        ticks
                        hide-details
                        label="Chance %"
                      >
                        <template v-slot:thumb-label="item">
                          <span>{{ item.value }}%</span>
                        </template>
                      </v-slider>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-checkbox
                        label="Action Needed"
                        v-model="formData.actionNeeded"
                        hide-details
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6 class="px-1 mb-1">
                      <v-autocomplete
                        label="Person Responsible"
                        v-model="formData.personResponsible_user_id"
                        item-text="fullName"
                        item-value="id"
                        :items="users"
                        hide-details
                        clearable
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex
                      xs4
                      v-if="formData.businessLeadsInformation_id != ''"
                      class="px-1 mb-1"
                    >
                      <datepicker
                        :sentDate="this.formData.lead_createdDate"
                        label="Lead Created (Not editable)"
                        @dateChanged="updateNotEditable"
                      ></datepicker>
                    </v-flex>
                    <v-flex
                      xs4
                      v-if="formData.businessLeadsInformation_id != ''"
                      class="px-1 mb-1"
                    >
                      <datepicker
                        :sentDate="this.formData.lead_actionTaken"
                        label="Lead Action Taken (Not editable)"
                        @dateChanged="updateFutureFollowUp"
                      ></datepicker>
                    </v-flex>

                    <v-flex class="px-1 mb-1">
                      <datepicker
                        :sentDate="this.formData.followUpAction"
                        label="Future Follow Up"
                        @dateChanged="updateFutureFollowUp"
                      ></datepicker>
                    </v-flex>
                    <v-flex
                      v-if="formData.specialFieldLabel != ''"
                      xs12
                      class="px-1 mb-1"
                    >
                      <v-text-field
                        label="Supplier Extra Field"
                        v-model="formData.specialField"
                        readonly
                        :hint="formData.specialFieldLabel"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              v-if="
                !userData.role.includes('Admin') &&
                $route.name != 'SalesEnquiryAdminBuyerView'
              "
              class="mb-4"
              xs12
            >
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar color="#4cc7e8" dense dark class="mb-0">
                  Actions needed by you
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        dark
                        class="ml-4"
                        flat
                        v-on="on"
                        @click="toggleReportIssue()"
                      >
                        <v-icon left>mdi-alert</v-icon>
                        <span class="mt-1">Report Issue</span>
                      </v-btn>
                    </template>
                    <span>Click to contact upstream.co.nz</span>
                  </v-tooltip>

                  <report-issue ref="reportIssueDialog"> </report-issue>

                  <v-spacer></v-spacer>

                  <span class="textLabel">Type of Sale:&nbsp;</span>
                  {{ formData.impactBusiness_id ? "Impact Buyer" : "Consumer" }}
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 lg8 class="px-1 mb-1">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <p style="font-weight: bold">The Enquiry Progress</p>

                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.upstreamStatus == 'Enquiry'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.upstreamStatus = 'Enquiry';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="Enquiry"
                          >
                            New Enquiry
                          </v-btn>
                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.upstreamStatus == 'In Progress'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.upstreamStatus = 'In Progress';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="In Progress"
                          >
                            In Progress
                          </v-btn>
                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.upstreamStatus == 'Completed'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.upstreamStatus = 'Completed';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="Completed"
                          >
                            Completed
                          </v-btn>
                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.upstreamStatus == 'Fallen Through'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.upstreamStatus = 'Fallen Through';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="Fallen Through"
                          >
                            Fell Through
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 class="px-1 mb-1 mt-3">
                          <p style="font-weight: bold">The Enquiry Outcome</p>

                          <v-layout row wrap>
                            <v-flex xs12 sm6 class="px-1 mb-1 py-0 mb-0">
                              <v-text-field
                                label="What was the total revenue of this sale? (EXCLUDE GST)"
                                prefix="$"
                                v-model="formData.supplierInputtedRevenue"
                                type="number"
                                hide-details
                                v-on:blur="formData.revenueChanged = 1; save(false);"
                              ></v-text-field>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              v-if="formData.specialFieldLabel != ''"
                              class="px-1 mb-1 py-0 mb-0"
                            >
                              <v-text-field
                                :label="formData.specialFieldLabel"
                                v-model="formData.specialField"
                                v-on:blur="save(false)"
                                hide-details
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 class="px-1 mb-1 mt-3">
                          <p style="font-weight: bold" class="mb-0">
                            Notes for UpstreamNZ
                          </p>

                          <v-layout row wrap>
                            <v-flex xs12 class="px-1 mb-1 py-0 mb-0">
                              <v-textarea
                                label="Enquiry Comments/Notes"
                                v-model="formData.supplierNotes"
                                v-on:blur="
                                  formData.commentsChanged = 1;
                                  save(false);
                                "
                                hide-details
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              v-if="
                !userData.role.includes('Admin') &&
                $route.name != 'SalesEnquiryAdminView'
              "
              class="mb-4"
              xs12
            >
              <v-card class="ma-2" elevation="5" style="height: 100%">
                <v-toolbar color="#325181" dense dark class="mb-0">
                  Feedback on the Enquiry - Please change status if not accurate
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 lg8 class="px-1 mb-1">
                      <v-layout row wrap>
                        <v-flex xs12 class="px-1 mb-1 mt-3">
                          <p style="font-weight: bold" class="mb-0">
                            The status our records show is:
                            <span style="color: red">{{
                              formData.upstreamStatus
                            }}</span>
                          </p>

                          <p>Is this right?</p>
                        </v-flex>
                        <v-flex xs12>
                          <p style="font-weight: bold">
                            Please change status if not accurate to our records
                          </p>
                          <!-- TODO: Have these buttons follow IB Status -->
                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.ibStatus == 'In Progress'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.ibStatus = 'In Progress';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="In Progress"
                          >
                            In Progress
                          </v-btn>
                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.ibStatus == 'Completed'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.ibStatus = 'Completed';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="Completed"
                          >
                            Completed
                          </v-btn>
                          <v-btn
                            style="background: #4cc7e8"
                            :color="
                              formData.ibStatus == 'Fallen Through'
                                ? '#4cc7e8'
                                : 'grey'
                            "
                            dark
                            @click="
                              formData.ibStatus = 'Fallen Through';
                              formData.statusChanged = 1;
                              save(false);
                            "
                            value="Fallen Through"
                          >
                            Fallen Through
                          </v-btn>
                        </v-flex>

                        <v-flex xs12 class="px-1 mb-1 mt-3">
                          <p style="font-weight: bold" class="mb-0">
                            Notes for Upstream
                          </p>

                          <v-layout row wrap>
                            <v-flex xs12 class="px-1 mb-1 py-0 mb-0">
                              <v-textarea
                                label="Comments/Notes specific to this enquiry"
                                v-model="formData.ibNotes"
                                v-on:blur="
                                  formData.commentsChanged = 1;
                                  save(false);
                                "
                                hide-details
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="linkToLeadDialog" max-width="600px">
      <v-card>
        <v-toolbar dense color="grey darken-2" dark> Link To Lead </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field label="Lead ID" v-model="linkedLeadID">
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn
                block
                color="success"
                :loading="linkToLeadLoading"
                @click="linkToLead"
                >Link</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-sheet>
  <v-sheet v-else>
    <div style="margin: auto; width: 50px; padding-top: calc(25% - 25px)">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-sheet>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import Vue from "vue";
  import datepicker from "@/components/wrappers/datepicker.vue";
  import reportIssue from "@/components/general/reportIssue.vue";

  export default {
    props: ["formOpen", "selectedData"],
    components: { datepicker, reportIssue },
    data: () => ({
      // Specific Data

      saving: false,
      deleting: false,
      formData: {},

      upstreamStatusList: [
        "Enquiry",
        "In Progress",
        "Completed",
        "Fallen Through",
        "Introduction",
      ],
      viaOptions: [
        {
          title: "Email off Website",
          description: "(Enquiry)",
        },
        {
          title: "Call Tracking",
          description: "(Enquiry)",
        },
        {
          title: "Repeat Sale",
          description: "(Manual Duplicate)",
        },

        {
          title: "Affiliate",
          description: "(Enquiry)",
        },
        {
          title: "Brokered Lead",
          description: "(Admin Inputted)",
        },
        {
          title: "Connection",
          description: "(Supplier Email)",
        },
        {
          title: "Backdoor Sale",
          description: "(Admin Inputted)",
        },
        {
          title: "Alias Email",
          description: "(Admin Inputted)",
        },
        {
          title: "Other",
          description: "",
        },
      ],

      linkToLeadDialog: false,
      linkedLeadID: "",
      linkToLeadLoading: false,
      creatingImpactBuyer: false,
    }),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
        goodCauses: "goodCauses/listOrderedByCategories",
        businesses: "business/listOrderedByNameSalesEnquiry",
        impactBusinesses: "impactBusinesses/listOrderedByName",
        categories: "categories/list",
        users: "user/staff",
        currentProfile: "business/salesEnquiryCurrentProfile",
      }),
    },
    watch: {
      selectedData: function () {
        this.loadEnquiry();
      },
    },
    mounted() {
      if (this.selectedData.hasOwnProperty("id")) {
        this.loadEnquiry();
      }
    },
    methods: {
      toggleReportIssue() {
        this.$refs.reportIssueDialog.toggleDialog();
      },
      loadEnquiry() {
        this.$store
          .dispatch("business/loadSpecificSalesEnquiry", this.selectedData.id)
          .then(() => {
            let enquiry = JSON.parse(JSON.stringify(this.currentProfile));
            this.open(enquiry, this.selectedData.id);
          });
      },

      open(enquiry) {
        this.image = null;
        this.saving = false;
        this.formData = enquiry;
        this.formData.paidToGC = parseInt(this.formData.paidToGC);
        this.formData.repeatSale = parseInt(this.formData.repeatSale);
        this.formData.actionNeeded = parseInt(this.formData.actionNeeded);
      },
      save(closeOnSaved = true) {
        this.saving = true;
        for (const [key, value] of Object.entries(this.formData)) {
          if (value == undefined || value == null) {
            delete this.formData[key];
          }
        }
        if (this.formData.hasOwnProperty("id")) {
          if (!this.formData.hasOwnProperty("impactBusiness_id")) {
            this.formData.impactBusiness_id = null;
          }
          this.$store
            .dispatch("business/salesEnquirySave", this.formData)
            .then(() => {
              delete this.formData.statusChanged;
              delete this.formData.commentsChanged;
              delete this.formData.revenueChanged;
              this.$emit("saved");
              // this.$swal("Saved", "This Sales Enquiry has been Saved", "success");
              if (closeOnSaved == true) {
                this.$router.push("/admin/salesEnquiry");
              }

              this.saving = false;
            });
        } else {
          this.$store
            .dispatch("business/salesEnquiryAdd", this.formData)
            .then(() => {
              this.$emit("saved");

              if (closeOnSaved) {
                this.$router.push("/admin/salesEnquiry");
              }
              this.saving = false;
            });
        }
      },
      deleteItem() {
        this.$swal
          .fire({
            icon: "warning",
            title: "Are you sure you want to delete this sale enquiry card?",
            showDenyButton: true,
            showCancelButton: true,
            cancelButtonText: `Don't Delete`,
            confirmButtonText: `Delete`,
            confirmButtonColor: "red",
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.deleting = true;
              this.$store
                .dispatch("business/deleteSalesEnquiry", this.formData.id)
                .then(() => {
                  this.deleting = false;
                  this.$emit("saved");

                  this.$swal(
                    "Deleted",
                    "The Sales Enquiry has been deleted",
                    "success"
                  );
                  this.$router.push("/admin/salesEnquiry");
                });
            }
          });
      },
      duplicateSalesEnquiry() {
        let payload = { id: this.formData.id };
        this.$store
          .dispatch("business/salesEnquiryDuplicate", payload)
          .then(() => {
            this.$emit("saved");
            this.$router.push("/admin/salesEnquiry");

            this.saving = false;
          });
      },
      updateCustomerInfo() {
        if (typeof this.formData.impactBusiness_id != "undefined") {
          let impactBusiness = JSON.parse(
            JSON.stringify(
              this.impactBusinesses.find(
                (ib) => ib.id == this.formData.impactBusiness_id
              )
            )
          );
          if (!this.formData.fullName || this.formData.fullName == "") {
            this.formData.fullName = impactBusiness.ownerName;
          }
          if (!this.formData.email || this.formData.email == "") {
            this.formData.email = impactBusiness.impactEmail;
          }
          if (!this.formData.mobile || this.formData.mobile == "") {
            this.formData.mobile = impactBusiness.impactPhone;
          }
          if (!this.formData.address || this.formData.address == "") {
            this.formData.address = impactBusiness.impactAddress;
          }
        }
      },
      updateSupplierInfo() {
        if (typeof this.formData.business_id != "undefined") {
          let supplier = JSON.parse(
            JSON.stringify(
              this.businesses.find((b) => b.id == this.formData.business_id)
            )
          );

          let categories = JSON.parse(
            JSON.stringify(
              this.categories.filter((c) =>
                supplier.category.split(",").includes(c.id)
              )
            )
          );
          this.formData.businessCategories = "";
          this.formData.businessSubCategories = "";
          let subCategories = [];
          categories.forEach((category) => {
            let subCategory = category.children.filter((c) =>
              supplier.subCategory.split(",").includes(c.id)
            );
            subCategories = subCategories.concat(subCategory);
            this.formData.businessCategories = `${this.formData.businessCategories}${category.name}, `;
          });
          subCategories.forEach((subCat) => {
            this.formData.businessSubCategories = `${this.formData.businessSubCategories}${subCat.name}, `;
          });
        }
      },
      linkToLead() {
        let payload = {
          leadID: this.linkedLeadID,
          salesEnquiryID: this.formData.id,
        };
        this.linkToLeadLoading = true;
        this.$store.dispatch("leads/linkSalesEnquiryToLead", payload).then(() => {
          this.linkToLeadLoading = false;
          this.linkToLeadDialog = false;
          this.formData.businessLeadsInformation_id = this.linkedLeadID;
        });
      },
      updateFutureFollowUp(date) {
        this.formData.followUpAction = date;
      },
      updateNotEditable(date) {
        this.formData.followUpAction = this.formData.followUpAction;
      },
      createImpactBuyer() {
        this.creatingImpactBuyer = true;
        this.$store
          .dispatch("impactBusinesses/createFromSalesEnquiry", this.formData)
          .then((res) => {
            this.creatingImpactBuyer = false;
            this.formData.impactBusiness_id = res.impactBusiness_id;
          });
      },
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
  window.dateFormatter = function dateFormatter(params) {
    if (params.data.dateOfEnquiry) {
      return moment
        .utc(params.data.dateOfEnquiry)
        .local()
        .format("DD-MMM, h:mma");
    } else {
      return "";
    }
  };
  window.yearFormatter = function yearFormatter(params) {
    if (params.data.dateOfEnquiry) {
      return moment.utc(params.data.dateOfEnquiry).local().format("YYYY");
    } else {
      return "";
    }
  };
</script>

<style>
  .croppa-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .icon-remove {
    position: absolute;
    top: 5px !important;
    right: -35px !important;
  }

  .croppa-container canvas {
    border: 1px solid;
  }
</style>

<style scoped>
  .textLabel {
    font-weight: 500;
  }
</style>
